import { CHANGE_PASSWORD_SUCCESS, CHANGE_PASSWORD_FAILURE } from '../constants/MTag';

const initStat = { data: [], error: false, errorData: '', isLoading: true };

export default (state = initStat, action) => {
	switch (action.type) {
		case CHANGE_PASSWORD_SUCCESS:
			return {
				...state,
				data: action.payload,
				isLoading: false,
			};
		case CHANGE_PASSWORD_FAILURE:
			return {
				...state,
				isLoading: false,
				errorData: action.payload,
				error: true,
			};
		default:
			return { ...state };
	}
};
